import styles from "./header-button.module.less";

export type THeaderButtonProps = {
  children?: React.ReactNode;
  icon?: string;
  label?: string;
  isActive?: boolean;
  className?: string;
  noSeparator?: boolean;
  hideMobile?: boolean;
  ariaLabel?: string;
  onClick?: () => void;
};

export const HeaderButton = ({
  label,
  icon,
  children,
  isActive,
  className,
  noSeparator,
  hideMobile,
  ariaLabel,
  onClick,
}: THeaderButtonProps) => {
  const iconOnly = !label && !children && icon;

  return (
    <div
      className={[
        styles.wrapper,
        className,
        noSeparator ? styles.noSeparator : "",
        hideMobile ? styles.hideMobile : "",
      ].join(" ")}
    >
      <button
        aria-label={ariaLabel || label}
        className={[styles.button, className, isActive ? styles.active : ""].join(" ")}
        onClick={onClick}
      >
        {children}
        {icon && <span className={[styles.icon, icon, iconOnly ? styles.iconOnly : ""].join(" ")}>{}</span>}
        {label && <span className={styles.label}>{label}</span>}
      </button>
    </div>
  );
};
